type AnnouncerProps = {
  message: string
  className?: string
}

export function Announcer({ message, className }: AnnouncerProps) {
  return (
    <div role="alert" aria-live="assertive" aria-atomic="true" className={className}>
      {message || '\u00A0'}
    </div>
  )
}
